"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNormalizedRefs = void 0;
const react_1 = __importDefault(require("react"));
const setRef = (ref, value) => {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
};
/** A hook for normalizing two refs. Ensures that two refs have the same value.
 * Best used for supporting forwarded refs when your internal code relies on the
 * the presence of a ref.
 *
 * @param {React.Ref<T>} refA the first ref to normalize
 * @param {React.Ref<T>} refB the second ref to normalize
 *
 * @returns the normalized ref
 */
const useNormalizedRefs = (refA, refB) => {
    return react_1.default.useMemo(() => {
        if (refA == null && refB == null) {
            return null;
        }
        return (refValue) => {
            setRef(refA, refValue);
            setRef(refB, refValue);
        };
    }, [refA, refB]);
};
exports.useNormalizedRefs = useNormalizedRefs;
//# sourceMappingURL=useNormalizedRefs.js.map